import {
  DefaultLightningDuration,
  getLightningLabel,
  getSmallerlightningDurationsAndItself,
  isLightningDuration,
  lightningColorRange,
} from "@/geojson/definitions";
import React, { Fragment } from "react";
import styles from "./MapLegend.module.scss";

const GradientStops = ({ colors }: { colors: string[] }) => {
  const numColors = colors.length;
  const step = 100 / numColors;

  return (
    <>
      {[...colors].reverse().map((color, index) => (
        <Fragment key={`${index}_${color}`}>
          <stop offset={`${index * step}%`} stopColor={color} />
          {index < numColors - 1 && <stop offset={`${(index + 1) * step}%`} stopColor={color} />}
        </Fragment>
      ))}
    </>
  );
};

const LabelGenerator = ({ labels, rectHeight }: { labels: string[]; rectHeight: number }) => {
  const numColors = labels.length;
  const step = rectHeight / numColors;

  return (
    <>
      {[...labels].reverse().map((label, index) => (
        <text
          key={`${index}_${label}`}
          x="46"
          y={rectHeight - (index + 0.5) * step}
          dominantBaseline="middle"
          fill="black"
          fontWeight={8000}
          fontSize="210%"
        >
          {label}
        </text>
      ))}
    </>
  );
};

export interface LightningMapLegendProps {
  parameter: string;
}

export const LightningMapLegend = ({ parameter }: LightningMapLegendProps) => {
  const lightningDurations = getSmallerlightningDurationsAndItself(
    isLightningDuration(parameter) ? parameter : DefaultLightningDuration,
  );
  const slicedLightningColorRange = lightningColorRange.slice(0, lightningDurations.length);
  const labels = lightningDurations.map((duration) => getLightningLabel(duration));

  return (
    <div className={styles["map-legend"]}>
      <svg
        viewBox="0 0 200 1000"
        data-transfer-function="49-precip__type___idx-419"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        width="100%"
        height="100%"
      >
        <defs>
          <linearGradient id="49-precip__type___idx-419" gradientTransform="rotate(270)" spreadMethod="repeat">
            ${<GradientStops colors={slicedLightningColorRange} />}
          </linearGradient>
        </defs>
        <g>
          <rect
            x="-40"
            y="20"
            width="30"
            height="960"
            fill="url(#49-precip__type___idx-419)"
            stroke="black"
            strokeWidth="1"
          />
        </g>
        ${<LabelGenerator labels={labels} rectHeight={1000} />}
      </svg>
    </div>
  );
};
